import { logApiEvent } from '@analytics/amplifyLogging';
import AccConnectFormSubmit from '@components/AccountConnectFormSubmit/AccConnectFormSubmit';
import LoadingBar from '@components/LoadingBar/LoadingBar';
import { getAccountConnectToken } from '@services/AccountConnectFormService';
import { dispatch } from '@store';
import { ssoAction } from '@store/actions/sso.action';
import { setNotification } from '@store/errors';
import { clearCookie } from '@utils/cookieHelper';
import React, { Component, Fragment, ReactNode } from 'react';
import { auth, config } from '../config';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    url: string;
    token: string;
}

const accountDetailSSO = async (url: string) => {
    dispatch(ssoAction());
    const { response, error } = await getAccountConnectToken(`${config.env('ssoUrl')}`, `${config.env('xApiKey')}`);

    if (response) {
        auth.getOkta().tokenManager.clear();
        clearCookie();
        return { url, token: response?.signinToken };
    } else if (error) {
        dispatch(setNotification(error));
    }
};

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        url: '',
        token: ''
    };

    public static getDerivedStateFromError(_: Error): State {
        return { hasError: true, url: '', token: '' };
    }

    public async componentDidCatch(error: any, errorInfo: any) {
        logApiEvent({
            description: 'Browser console error captured from Error Boundry',
            error: error.message,
            type: 'Error Boundry Component',
            action: ''
        });

        const res = await accountDetailSSO(`${config.env('myLoanBaseUrl')}/LoanService/SSOPost`);

        this.setState({ hasError: true, url: res?.url, token: res?.token });
    }

    public render() {
        const { hasError, url, token } = this.state;
        if (hasError) {
            return (
                <Fragment data-testid="error_boundry">
                    <LoadingBar />
                    {url !== '' && token !== '' && <AccConnectFormSubmit method="post" action={url} value={token} />}
                </Fragment>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
